// Animate.CSS main function
$.fn.extend({
  animateCss: function(animationName, callback) {
    var animationEnd = (function(el) {
      var animations = {
        animation: 'animationend',
        OAnimation: 'oAnimationEnd',
        MozAnimation: 'mozAnimationEnd',
        WebkitAnimation: 'webkitAnimationEnd',
      };

      for (var t in animations) {
        if (el.style[t] !== undefined) {
          return animations[t];
        }
      }
    })(document.createElement('div'));

    this.addClass('animated ' + animationName).one(animationEnd, function() {
      $(this).removeClass('animated ' + animationName);

      if (typeof callback === 'function') callback();
    });

    return this;
  },
});

(function() {
    // Bootstrap Init:
    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });

    // Mobile Navigation
    $('.mobile-nav__toggle').click(function(){
        var hidden = $('.mobile-nav__content').hasClass('d-none'),
        wrapper = $('.mobile-nav__content'),
        content = $('.mobile-nav__content .container');


        if(!hidden){
          $('.mobile-nav__toggle').removeClass('mobile-nav__toggle--on');

          content.animateCss('fadeOutUp', function() {
            content.addClass('d-none');
          });

          wrapper.animateCss('fadeOut', function() {
            wrapper.addClass('d-none');
          });
        } else{
          $('.mobile-nav__toggle').addClass('mobile-nav__toggle--on');
          wrapper.removeClass('d-none');
          wrapper.animateCss('fadeIn');

          content.removeClass('d-none');
          content.animateCss('fadeInDown');
        }
    });

    // scroll to anchor animation
    $('a[href^="#"]').on('click', function(e) {
        e.preventDefault();

        var target = this.hash;
        var $target = $(target);
        var parent = $(this).parents('nav').attr('class');

        $('html, body').stop().animate({
            'scrollTop': $target.offset().top
        }, 900, 'swing', function() {
            window.location.hash = target;
        });

        if(parent === "mobile-nav-links-wrapper"){
            $('.mobile-nav__toggle').toggleClass('mobile-nav__toggle--on');
            $('.mobile-nav__content').fadeToggle( 100, "linear" );
            $('.mobile__content').removeClass('mobile-nav--hide');
        }
    });


    // same boxes height
    function sameHeight(target){
        var highestBox = 0;
        $(target).each(function(){
          if($(this).height() > highestBox) {
            highestBox = $(this).height();
          }
        });
        $(target).height(highestBox);
    }


    // Scrolling Efects
    function scrollEfects() {
        var width = $(window).width(),
            height = $(window).height(),
            wScroll = $(this).scrollTop(),
            targets = $('.masthead .brand'),
            itemsWrapperHeight = $('.items-wrapper').height();

        // on homepage only
        if (  width >= 992){
            $('.header-illustration .main').first().css({
                'transform': 'translate(0px, -' + wScroll / 20 + '%)'
            });

            $('.header__shape').first().css({
                'transform': 'translate(0px, ' + wScroll / 50 + '%)'
            });

            $('.header-illustration .back1').last().css({
                'transform': 'translate(0px, -' + wScroll / 5 + '%)'
            });
            $('.header-illustration .back2').last().css({
                'transform': 'translate(0px, -' + wScroll / 3 + '%)'
            });
        }
    }

    //Triggers for the above function
    $(window).resize(scrollEfects);
    $(window).scroll(scrollEfects);

    $( document ).ready(function() {
        $('.header-tagline').removeClass('v-hidden');
        $('.header-tagline, .header-illustration .main').animateCss('fadeIn');

        $('.header-illustration .back1, .header-illustration .back2').animateCss('fadeInDown');
        // $('.header-tagline, header-illustration .main').animateCss('fadeIn');
    });


    // Featured projects hover effects (without dealy)
    // $('.project-box').hover(function() {
    //   var box = $(this);
    //
    //   if( box.hasClass('project-box--small') ){
    //     // alert('ta');
    //   }
    //
    //   box.closest('.row').children('.col-lg-8').removeClass('col-lg-8').addClass('col-lg-4');
    //   box.closest('.row').find('.project-box--large').removeClass('project-box--large').addClass('project-box--small');
    //
    //   box.closest('.col-lg-4').removeClass('col-lg-4').addClass('col-lg-8');
    //   box.removeClass('project-box--small').addClass('project-box--large');
    // });


    var timeoutId;
    $(".project-box").hover(function() {
        var box = $(this);

        if (!timeoutId) {
          timeoutId = window.setTimeout(function() {
            timeoutId = null; // EDIT: added this line

            box.closest('.row').children('.col-lg-8').removeClass('col-lg-8').addClass('col-lg-4');
            box.closest('.row').find('.project-box--large').removeClass('project-box--large').addClass('project-box--small');

            box.closest('.col-lg-4').removeClass('col-lg-4').addClass('col-lg-8');
            box.removeClass('project-box--small').addClass('project-box--large');

          }, 200);
        }
      },
      function() {
        if (timeoutId) {
          window.clearTimeout(timeoutId);
          timeoutId = null;
        } else {
          // $("#SeeAllEvents").slideUp('slow');
        }
      });

})();
